import React from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import FolderIcon from '../assets/icons/folder.svg';

const categoryLinkBuilder = (item) => {
  switch (item.__typename) {
    case 'DatoCmsModule':
      return item.slug;
    case 'DatoCmsModuleSubCategory':
      return item.slug;
    default:
      console.warn(`Unknown item type: ${item.__typename}`);
      return '#';
  }
};

export const generateNavLink = (linkType, item) => {
  switch (linkType) {
    case 'page':
      return item.page?.slug ? `/${item.page.slug}` : null;

    case 'external':
      return item.externalLink?.[0]?.url ?? null;

    case 'category':
      return item.category?.length
        ? `/modules/${item.category.map((c) => categoryLinkBuilder(c)).join('/')}`
        : null;
    default:
      if (linkType) console.warn(`Unknown link type: ${linkType}`);
      return null;
  }
};

export const generateNavLabel = (item) => {
  const label =
    item.disabled || item.linkType !== 'external'
      ? item.label
      : item.externalLink?.[0]?.label || item.label;
  return item.disabled ? `${label} (coming soon)` : label;
};

export const renderNavIcon = (linkType, label) => {
  if (label.includes('Information')) {
    return <AiFillInfoCircle style={{ color: '#f592bf', fontSize: '21px', marginRight: '13px' }} />;
  }

  if (linkType === 'category') {
    return <img src={FolderIcon} alt="" className="nav-module-image" />;
  }
};
